const cache = {};
export const useCache = () => cache;
